// Generated from /Volumes/Data/Code/Cobham/neko-paie/backend/formula/src/main/antlr/com/cobhamsolutions/nekopaie/formula/parser/Formula.g4 by ANTLR 4.13.2
// jshint ignore: start
import antlr4 from 'antlr4';


const serializedATN = [4,0,24,151,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,
4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,
12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,
2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,1,0,1,0,1,1,1,1,1,2,1,
2,1,3,1,3,1,4,1,4,1,5,1,5,1,6,1,6,1,7,1,7,1,8,1,8,1,9,1,9,1,10,1,10,1,11,
1,11,1,11,1,12,1,12,1,12,1,13,1,13,1,13,1,14,1,14,1,14,1,15,1,15,1,15,1,
15,1,16,1,16,1,16,1,17,1,17,1,17,1,17,5,17,97,8,17,10,17,12,17,100,9,17,
1,17,1,17,1,18,4,18,105,8,18,11,18,12,18,106,1,18,1,18,1,19,1,19,1,20,1,
20,4,20,115,8,20,11,20,12,20,116,3,20,119,8,20,1,21,4,21,122,8,21,11,21,
12,21,123,1,22,4,22,127,8,22,11,22,12,22,128,1,22,1,22,4,22,133,8,22,11,
22,12,22,134,1,23,4,23,138,8,23,11,23,12,23,139,1,24,1,24,1,24,1,24,4,24,
146,8,24,11,24,12,24,147,1,24,1,24,0,0,25,1,1,3,2,5,3,7,4,9,5,11,6,13,7,
15,8,17,9,19,10,21,11,23,12,25,13,27,14,29,15,31,16,33,17,35,18,37,19,39,
20,41,0,43,21,45,22,47,23,49,24,1,0,7,2,0,10,10,13,13,3,0,9,10,13,13,32,
32,1,0,49,57,1,0,48,57,2,0,44,44,46,46,6,0,36,36,46,46,48,57,65,90,95,95,
97,122,1,0,34,34,159,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,
1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,
0,21,1,0,0,0,0,23,1,0,0,0,0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,
0,0,0,0,33,1,0,0,0,0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,43,1,0,0,0,0,
45,1,0,0,0,0,47,1,0,0,0,0,49,1,0,0,0,1,51,1,0,0,0,3,53,1,0,0,0,5,55,1,0,
0,0,7,57,1,0,0,0,9,59,1,0,0,0,11,61,1,0,0,0,13,63,1,0,0,0,15,65,1,0,0,0,
17,67,1,0,0,0,19,69,1,0,0,0,21,71,1,0,0,0,23,73,1,0,0,0,25,76,1,0,0,0,27,
79,1,0,0,0,29,82,1,0,0,0,31,85,1,0,0,0,33,89,1,0,0,0,35,92,1,0,0,0,37,104,
1,0,0,0,39,110,1,0,0,0,41,118,1,0,0,0,43,121,1,0,0,0,45,126,1,0,0,0,47,137,
1,0,0,0,49,141,1,0,0,0,51,52,5,58,0,0,52,2,1,0,0,0,53,54,5,44,0,0,54,4,1,
0,0,0,55,56,5,43,0,0,56,6,1,0,0,0,57,58,5,45,0,0,58,8,1,0,0,0,59,60,5,42,
0,0,60,10,1,0,0,0,61,62,5,47,0,0,62,12,1,0,0,0,63,64,5,40,0,0,64,14,1,0,
0,0,65,66,5,41,0,0,66,16,1,0,0,0,67,68,5,33,0,0,68,18,1,0,0,0,69,70,5,62,
0,0,70,20,1,0,0,0,71,72,5,60,0,0,72,22,1,0,0,0,73,74,5,62,0,0,74,75,5,61,
0,0,75,24,1,0,0,0,76,77,5,60,0,0,77,78,5,61,0,0,78,26,1,0,0,0,79,80,5,61,
0,0,80,81,5,61,0,0,81,28,1,0,0,0,82,83,5,33,0,0,83,84,5,61,0,0,84,30,1,0,
0,0,85,86,5,65,0,0,86,87,5,78,0,0,87,88,5,68,0,0,88,32,1,0,0,0,89,90,5,79,
0,0,90,91,5,82,0,0,91,34,1,0,0,0,92,93,5,47,0,0,93,94,5,47,0,0,94,98,1,0,
0,0,95,97,8,0,0,0,96,95,1,0,0,0,97,100,1,0,0,0,98,96,1,0,0,0,98,99,1,0,0,
0,99,101,1,0,0,0,100,98,1,0,0,0,101,102,6,17,0,0,102,36,1,0,0,0,103,105,
7,1,0,0,104,103,1,0,0,0,105,106,1,0,0,0,106,104,1,0,0,0,106,107,1,0,0,0,
107,108,1,0,0,0,108,109,6,18,1,0,109,38,1,0,0,0,110,111,3,41,20,0,111,40,
1,0,0,0,112,119,5,48,0,0,113,115,7,2,0,0,114,113,1,0,0,0,115,116,1,0,0,0,
116,114,1,0,0,0,116,117,1,0,0,0,117,119,1,0,0,0,118,112,1,0,0,0,118,114,
1,0,0,0,119,42,1,0,0,0,120,122,7,3,0,0,121,120,1,0,0,0,122,123,1,0,0,0,123,
121,1,0,0,0,123,124,1,0,0,0,124,44,1,0,0,0,125,127,7,3,0,0,126,125,1,0,0,
0,127,128,1,0,0,0,128,126,1,0,0,0,128,129,1,0,0,0,129,130,1,0,0,0,130,132,
7,4,0,0,131,133,7,3,0,0,132,131,1,0,0,0,133,134,1,0,0,0,134,132,1,0,0,0,
134,135,1,0,0,0,135,46,1,0,0,0,136,138,7,5,0,0,137,136,1,0,0,0,138,139,1,
0,0,0,139,137,1,0,0,0,139,140,1,0,0,0,140,48,1,0,0,0,141,145,5,34,0,0,142,
146,8,6,0,0,143,144,5,34,0,0,144,146,5,34,0,0,145,142,1,0,0,0,145,143,1,
0,0,0,146,147,1,0,0,0,147,145,1,0,0,0,147,148,1,0,0,0,148,149,1,0,0,0,149,
150,5,34,0,0,150,50,1,0,0,0,11,0,98,106,116,118,123,128,134,139,145,147,
2,0,1,0,6,0,0];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

export default class FormulaLexer extends antlr4.Lexer {

    static grammarFileName = "Formula.g4";
    static channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	static modeNames = [ "DEFAULT_MODE" ];
	static literalNames = [ null, "':'", "','", "'+'", "'-'", "'*'", "'/'", 
                         "'('", "')'", "'!'", "'>'", "'<'", "'>='", "'<='", 
                         "'=='", "'!='", "'AND'", "'OR'" ];
	static symbolicNames = [ null, null, null, "PLUS", "MINUS", "TIMES", "DIVIDE", 
                          "LPAREN", "RPAREN", "NOT", "GT", "LT", "GTE", 
                          "LTE", "EQ", "NE", "AND", "OR", "LINE_COMMENT", 
                          "WS", "INTEGER", "INTEGER_LEADING_ZERO", "FLOAT", 
                          "IDENTIFIER", "STRING" ];
	static ruleNames = [ "T__0", "T__1", "PLUS", "MINUS", "TIMES", "DIVIDE", 
                      "LPAREN", "RPAREN", "NOT", "GT", "LT", "GTE", "LTE", 
                      "EQ", "NE", "AND", "OR", "LINE_COMMENT", "WS", "INTEGER", 
                      "NonLeadingZeroInteger", "INTEGER_LEADING_ZERO", "FLOAT", 
                      "IDENTIFIER", "STRING" ];

    constructor(input) {
        super(input)
        this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.atn.PredictionContextCache());
    }
}

FormulaLexer.EOF = antlr4.Token.EOF;
FormulaLexer.T__0 = 1;
FormulaLexer.T__1 = 2;
FormulaLexer.PLUS = 3;
FormulaLexer.MINUS = 4;
FormulaLexer.TIMES = 5;
FormulaLexer.DIVIDE = 6;
FormulaLexer.LPAREN = 7;
FormulaLexer.RPAREN = 8;
FormulaLexer.NOT = 9;
FormulaLexer.GT = 10;
FormulaLexer.LT = 11;
FormulaLexer.GTE = 12;
FormulaLexer.LTE = 13;
FormulaLexer.EQ = 14;
FormulaLexer.NE = 15;
FormulaLexer.AND = 16;
FormulaLexer.OR = 17;
FormulaLexer.LINE_COMMENT = 18;
FormulaLexer.WS = 19;
FormulaLexer.INTEGER = 20;
FormulaLexer.INTEGER_LEADING_ZERO = 21;
FormulaLexer.FLOAT = 22;
FormulaLexer.IDENTIFIER = 23;
FormulaLexer.STRING = 24;



